// extracted by mini-css-extract-plugin
module.exports = {"item_name":"itemInMenuContent_item_name__3K0Gy","disabled":"itemInMenuContent_disabled__tzjAo"};